import { combineReducers } from '@reduxjs/toolkit';

import { basicAuthStore } from './basic-auth-slice';

export const authenticationMethodsStore = {
    authenticationMethods: combineReducers({
        ...basicAuthStore
    })
};
